import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/styles/index.scss'

// element-ui
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-CN'

// editor
import SmeEditor from '@/components/SmeEditor'

import '@/icons'
import '@/layouts'
import '@/permission'
import * as filters from '@/filters'

const IMG_SERVER = process.env.VUE_APP_IMG_SERVER

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.use(ElementUI, { locale })
Vue.use(SmeEditor, {
  name: 'sme-editor',
  language: 'zh-cn',
  showModuleName: true,
  image: {
    sizeLimit: 512 * 1024,
    compress: false,
    upload: {
      url: IMG_SERVER,
      headers: {},
      params: {},
      fieldName: 'file'
    },
    uploadHandler (responseText) {
      const json = JSON.parse(responseText)

      if (json.file_id) {
        return `${IMG_SERVER}/${json.file_id}`
      }
    }
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
